import React from 'react';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import MentorMenteeAvailabilityBody from './body'
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

export const exportEventName = "mentorMenteeAvailabilityExportChart";

const MentorMenteeAvailability = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs(props);

  const configBuilder = (_state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MentorMenteeAvailabilityBody, {})
    };
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default MentorMenteeAvailability;
